import React, { useState } from "react";
import { Row, Col, notification, Modal, message } from "antd"; // Removed unnecessary imports
import AppsIcon from "@mui/icons-material/Apps";
import styled from "styled-components";
import { connect } from "react-redux";
import bdoLogo from "assets/icons/BDO-ICON.svg";
import TymeplusPay from "assets/icons/UI/TymeplusPayIcon.svg";
import { jwtDecode } from "jwt-decode";
import { Fab, Zoom, Tooltip, ClickAwayListener } from "@mui/material";
import { getUserInfo } from "redux/selectors";

const Styleddiv = styled.div`
  .active_icon {
    background-color: #e3e8fc;
  }
  .app_icon {
    background-color: transparent;
    box-shadow: none;
  }
  .styled_container {
    background-color: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(199, 229, 255, 0.44);
  }
  .disabled-img {
    opacity: 0.5; /* Makes the image look disabled */
    cursor: not-allowed;
  }
  .enabled-img {
    cursor: pointer;
  }
`;

// Retrieve the JWT token
const jwtToken = window.localStorage.getItem("token");

const handleManagementView = () => {
  const hyperlink = `https://www.dev.mgntview.tymeplushr.com/?jwtToken=${jwtToken}`;
  window.open(hyperlink, "_blank");
};

const handleHR = () => {
  const hyperlink = `https://www.dev.app.system.tymeplushr.com/?token=${jwtToken}`;
  window.open(hyperlink, "_blank");
};
const handleLMS = () => {
  const hyperlink = `https://www.dev.learn.tymeplushr.com/?token=${jwtToken}`;
  window.open(hyperlink, "_blank");
};

const FloatingButton = ({ menuList, productInfo, userInfo }) => {

  const baseUrl = `${window?.location?.protocol}//${window?.location.host}`;

  const [open, setOpen] = useState(false);
  const toggleButtons = () => setOpen(!open);
  const userInformation = userInfo;

  const tokenData = localStorage.getItem("token");
  const clientid = jwtDecode(tokenData)?.clientId;

  console.log("userData1212--->", clientid);
  let token = null;
  try {
    if (jwtToken) {
      token = jwtDecode(jwtToken);
    }
  } catch (error) {
    console.error("Invalid token:", error);
  }

  const handleClickIcon = (link, access) => {
    if(access === true){
      const hyperlink = `${link}?token=${tokenData}`;
      window.open(hyperlink, "_blank");
    }else{
      message.error("This User Has not access")
    }
  }

  const handleWarning = () => {
    Modal.warning({
      title: "Access Denied",
      content:
        "Please reach out to our customer support or sales team to access the upgraded features.",
      okText: "OK",
    });
  };

  const items = [
    {
      key: "1",
      label: "BDO",
      access: false,
      link: "",
      logo: bdoLogo,
      onClick: () => handleClickIcon("", false),
    },
    {
      key: "2",
      label: "Pay",
      access: true,
      link: clientid === "C0001" ? "https://uat.zambia.pay.bdo.insyts.co/" : "https://uat.kenya.foresytspay.bdo.insyts.co", //UAT Link
      logo: TymeplusPay,
      onClick: () => clientid === "C0001" ? handleClickIcon("https://uat.zambia.pay.bdo.insyts.co/", true) : handleClickIcon("https://uat.kenya.foresytspay.bdo.insyts.co", true),
    }
  ];

  const handleClickAway = () => {
    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Styleddiv>
        <Fab
          className={open ? "active_icon" : "app_icon"}
          style={{ width: "36px", maxHeight: "36px" }}
          onClick={(e) => {e.preventDefault(); toggleButtons()}}
        >
          <AppsIcon />
        </Fab>

        {open && (
          <div
            className="styled_container"
            style={{
              position: "absolute",
              top: 76,
              left: 1,
              padding: "10px",
              width: "250px",
            }}
          >
            <Row>
              {items?.map((item) => (
                <Col sm={12} className="text-center p-2" key={item?.key}>
                  <img
                    src={item?.logo}
                    alt={item?.label}
                    className={item?.disabled ? "disabled-img" : "enabled-img"}
                    onClick={item?.onClick}
                  />
                  <h4>{item?.label}</h4>
                </Col>
              ))}
            </Row>
          </div>
        )}
      </Styleddiv>
    </ClickAwayListener>
  );
};

const mapStateToProps = (state) => ({
    userInfo: getUserInfo(state),
});

export default connect(mapStateToProps)(FloatingButton);